import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/download-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-18cf7d42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-f justify-b" }
const _hoisted_2 = { class: "tabs d-f" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Batch Tracking")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Program Tracking")
const _hoisted_5 = { class: "searchMain bg-fff m-t-8" }
const _hoisted_6 = { class: "d-f" }
const _hoisted_7 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_8 = { class: "label-text-121" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Batch Name: ")
const _hoisted_10 = { class: "text-bold" }
const _hoisted_11 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_12 = { class: "label-text-121" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Submit Date: ")
const _hoisted_14 = { class: "text-bold" }
const _hoisted_15 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_16 = { class: "label-text-121" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("CBU Budget: ")
const _hoisted_18 = { class: "text-bold" }
const _hoisted_19 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_20 = { class: "label-text-112" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("PbP Budget: ")
const _hoisted_22 = { class: "text-bold" }
const _hoisted_23 = { class: "d-f m-t-16" }
const _hoisted_24 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_25 = { class: "label-text-112" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("BU: ")
const _hoisted_27 = { class: "text-bold" }
const _hoisted_28 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_29 = { class: "label-text-112" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("NO. of Program: ")
const _hoisted_31 = { class: "text-bold" }
const _hoisted_32 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_33 = { class: "label-text-121" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Batch Total Budget: ")
const _hoisted_35 = { class: "text-bold" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16" }, null, -1))
const _hoisted_37 = { class: "d-f search-btns" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_40 = { class: "main bg-fff m-t-8 flex-w-auto d-f flex-d-c" }
const _hoisted_41 = { class: "d-f justify-b main-header" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f align-c" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title sign-line-b" }, "Program List")
], -1))
const _hoisted_43 = { class: "d-f align-c" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Export Combinability & Parameter")
const _hoisted_45 = { class: "d-f" }
const _hoisted_46 = { class: "table-wrapper flex-w-auto m-t-16" }
const _hoisted_47 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_program_preview = _resolveComponent("program-preview")!
  const _component_approve_confirm_modal = _resolveComponent("approve-confirm-modal")!
  const _component_WordingBudget = _resolveComponent("WordingBudget")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    header: _withCtx(() => [
      _createVNode(_component_breadcrumb, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("nav", _hoisted_2, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["tab", [_ctx.tag === 'pendingApprove' ? 'active' : null]]),
                to: "/approval/mg/packageHome"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Pending approval (" + _toDisplayString(_ctx.state.approve.pendingApproveCount) + ")", 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_router_link, {
                class: _normalizeClass(["tab", [_ctx.tag === 'batchTracking' ? 'active' : null]]),
                to: "/approval/mg/packageHome?tag=batchTracking"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_router_link, {
                class: _normalizeClass(["tab", [_ctx.tag === 'programTracking' ? 'active' : null]]),
                to: "/approval/mg/packageHome?tag=programTracking"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.packageDetail.batchName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.packageDetail.packageSubmitTime ? _ctx.moment(_ctx.packageDetail.packageSubmitTime).format('YYYY-MM-DD') : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.toThousands(_ctx.packageDetail.cbuBudget)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.toThousands(_ctx.packageDetail.pbpBudget)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.packageDetail.buName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.packageDetail.programDtos.length), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.toThousands(_ctx.packageDetail.totalBudget)), 1)
            ])
          ]),
          _hoisted_36
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_a_button, {
            class: "m-l-16",
            disabled: _ctx.batchStatus,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlerApprove('rejected')))
          }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            class: "m-l-16",
            disabled: _ctx.batchStatus,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlerApprove('approved')))
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_ApproveSteps, { data: _ctx.nodeList }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_a_button, {
              class: "m-l-16",
              type: "primary",
              onClick: _ctx.handleExport
            }, {
              default: _withCtx(() => [
                _hoisted_44
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("img", {
                title: "下载",
                src: _imports_0,
                alt: "",
                style: {"width":"20px"},
                class: "cursor-p m-l-12",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlerDownload && _ctx.handlerDownload(...args)))
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_a_table, {
            class: "tab-container default-self-table-text program-list-table",
            columns: _ctx.columns,
            dataSource: _ctx.packageDetail.programDtos,
            pagination: false,
            rowClassName: 
            (record, index) =>
              index === _ctx.currentClickRowIndex ? 'table-highlight' : index % 2 === 1 ? 'table-striped' : null
          ,
            rowKey: (item, index) => index
          }, {
            no: _withCtx(({ index }) => [
              _createTextVNode(_toDisplayString(++index), 1)
            ]),
            programName: _withCtx(({ text, record, index }) => [
              _createElementVNode("a", {
                title: text,
                href: "javascript:;",
                onClick: ($event: any) => (_ctx.handlerClickProgramName(record, index))
              }, _toDisplayString(text), 9, _hoisted_47)
            ]),
            from: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format('YYYY-MM-DD') : text), 1)
            ]),
            to: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format('YYYY-MM-DD') : text), 1)
            ]),
            pbpBudget: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(_ctx.toThousands(text)), 1)
            ]),
            cbuBudget: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(_ctx.toThousands(text)), 1)
            ]),
            vanBudget: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(text ? _ctx.toThousands(text) : '0'), 1)
            ]),
            totalBudget: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(_ctx.toThousands(text)), 1)
            ]),
            _: 1
          }, 8, ["columns", "dataSource", "rowClassName", "rowKey"]),
          _createVNode(_component_program_preview, {
            visible: _ctx.wordingVisible,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wordingVisible) = $event)),
            program: _ctx.programPreviewData,
            "onUpdate:program": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.programPreviewData) = $event))
          }, null, 8, ["visible", "program"])
        ])
      ]),
      _createVNode(_component_approve_confirm_modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
        comment: _ctx.approveComment,
        "onUpdate:comment": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.approveComment) = $event)),
        status: _ctx.approveStatus,
        onOnOk: _ctx.handlerOk
      }, null, 8, ["visible", "comment", "status", "onOnOk"]),
      (_ctx.visiblePreview)
        ? (_openBlock(), _createBlock(_component_WordingBudget, {
            key: 0,
            wordingpreviewvisible: _ctx.visiblePreview,
            "onUpdate:wordingpreviewvisible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visiblePreview) = $event))
          }, null, 8, ["wordingpreviewvisible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}